

import React, { memo, useState } from 'react';
import Popover from 'react-popover';
import { getStringValueFromGenericInput } from '@shootsta/get-value-from-generic-input';
import _memoize from 'lodash.memoize';
import { FormModal, Text, Input, Row, Col, ColorPicker, Button } from '../../../../ui-kit';

import './styles/_splash-details.scss';













const SplashDetails = (props) => {
  const {
    title,
    visible,
    onClose,
    action,
    templateId,
    updateTemplate,
    editDetails,
    setTemplateDetails
  } = props;
  const { status, brandingColor, templateName: splashTemplateName } = editDetails;

  const [templateName, setTemplateName] = useState(splashTemplateName);
  const [seedBrandingColor, setSeedBrandingColor] = useState(brandingColor);
  const [showPopover, setShowPopover] = useState(false);

  const onSave = async () => {
    await updateTemplate({
      templateId,
      action,
      optionalParams: {
        templateName,
        brandingColor: seedBrandingColor.startsWith('#') ? seedBrandingColor : `#${seedBrandingColor}`
      }
    });
    setTemplateDetails();
    onClose();
  };

  const updateInputField = _memoize(() => (result) => {
    const inputValue = getStringValueFromGenericInput(result);
    setTemplateName(inputValue);
  });

  const handlePickerColorChange = ({ hex = '' } = {}) => {
    setSeedBrandingColor(hex.toUpperCase());
  };

  const handleShowColorPicker = () => setShowPopover(true);

  const handleHideColorPicker = () => setShowPopover(false);

  return (
    <FormModal
      key="splash-details-modal"
      title={title}
      subtitle="View and manage details of this splash page"
      visible={visible}
      onClose={onClose}
      onSave={onSave}
      saveDisabled={!templateName}
      stayOpenOnSave
      saveText="Save Changes">

      <div className="splash-details-modal">
        <div className="splash-details-modal__basic-info">
          <Row nogutter>
            <Col sm={12} md={12} className="splash-details-modal__basic-info__details">
              <Text className="splash-details-modal__label">Splash ID#</Text>
              <Text label>{templateId}</Text>
            </Col>
          </Row>
          <Row nogutter>
            <Col sm={12} md={12} className="splash-details-modal__basic-info__details">
              <Text className="splash-details-modal__label">Status</Text>
              <Text label>{status === 'PUBLISHED' ? 'Published' : 'Draft'}</Text>
            </Col>
          </Row>
          <div className="splash-details-modal__basic-info__edit">
            <Text heading5>Basic Info</Text>
            <div className="splash-details-modal__basic-info__edit__section">
              <Row nogutter className="splash-details-modal__basic-info__edit__section__inputs">
                <Col md={12}>
                  <Input
                    id="pagename-input"
                    placeholder="Splash Page Name"
                    label="Splash Page Name"
                    labelProps={{ required: true }}
                    defaultValue={templateName}
                    value={templateName}
                    onChange={updateInputField('templateName')} />

                </Col>
                <hr />
                <Col md={12} className="splash-details-modal__basic-info__edit__section__inputs__theme">
                  <Text label>Theme</Text>
                  <Text className="splash-details-modal__basic-info__edit__section__inputs__theme__description">Your theme is the overall look, feel and style of your splash page</Text>
                  <div className="splash-details-modal__basic-info__edit__section__inputs__theme__details">
                    <div className="splash-details-modal__basic-info__edit__section__inputs__theme__details__info">
                      <span style={{ backgroundColor: seedBrandingColor }} className="splash-details-modal__basic-info__edit__section__inputs__theme__details__info__box" />
                      <span>{seedBrandingColor}</span>
                    </div>
                    <div className="splash-details-modal__basic-info__edit__section__inputs__theme__details__button-section">
                      <Popover
                        style={{ zIndex: 100 }}
                        isOpen={showPopover}
                        onOuterAction={handleHideColorPicker}
                        tipSize={0.01}
                        enterExitTransitionDurationMs={0}
                        body={
                        <ColorPicker
                          initialValue={{ hex: seedBrandingColor || '#323A45' }}
                          colourOnly
                          withHash
                          onSaveColor={handlePickerColorChange} />}>



                        <Button type="TERTIARY" onClick={handleShowColorPicker}>Update Theme</Button>
                      </Popover>
                    </div>
                  </div>
                </Col>
              </Row>

            </div>
          </div>

        </div>
      </div>
    </FormModal>);

};

export default memo(SplashDetails);